export enum ValuePosition {
  RIGHT = 'right',
  TOP = 'top',
  INSIDE = 'inside',
  BOTTOM = 'bottom',
}

export enum Units {
  DEFAULT = '%',
}

export enum ProgressBarMode {
  PRIMARY,
  PRIMARY_DARK,
  GREEN,
  BLUE,
  ERROR,
  SUCCESS,
}
